export default function LabelContent(
    args: any
) {
    return <span className="fc-timegrid-slot-label-text">
        {args.text}
    </span>
}